import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import { validatenull } from "@/util/validate";
import { registerGuest } from "@/api/user";
import { getTopUrl } from "@/util/util";
import { info } from "@/api/system/tenant";
import { resetRouter } from "@/router/router";
export default {
  name: "thirdRegister",
  data: function data() {
    return {
      form: {
        tenantId: '',
        name: '',
        account: '',
        password: '',
        password2: ''
      },
      loading: false,
      tenantMode: true,
      accountBox: false
    };
  },
  computed: _objectSpread({}, mapGetters(["userInfo"])),
  created: function created() {
    this.getTenant();
  },
  mounted: function mounted() {
    // 若未登录则弹出框进行绑定
    if (validatenull(this.userInfo.user_id) || this.userInfo.user_id < 0) {
      this.form.name = this.userInfo.user_name;
      this.form.account = this.userInfo.user_name;
      this.accountBox = true;
    }
  },
  methods: {
    handleRegister: function handleRegister() {
      var _this = this;

      if (this.form.tenantId === '') {
        this.$message.warning("请先输入租户编号");
        return;
      }

      if (this.form.account === '') {
        this.$message.warning("请先输入账号名称");
        return;
      }

      if (this.form.password === '' || this.form.password2 === '') {
        this.$message.warning("请先输入密码");
        return;
      }

      if (this.form.password !== this.form.password2) {
        this.$message.warning("两次密码输入不一致");
        return;
      }

      this.loading = true;
      registerGuest(this.form, this.userInfo.oauth_id).then(function (res) {
        _this.loading = false;
        var data = res.data;

        if (data.success) {
          _this.accountBox = false;

          _this.$alert("注册申请已提交,请耐心等待管理员通过!", '注册提示').then(function () {
            _this.$store.dispatch("LogOut").then(function () {
              resetRouter();

              _this.$router.push({
                path: "/login"
              });
            });
          });
        } else {
          _this.$message.error(data.msg || '提交失败');
        }
      }, function (error) {
        window.console.log(error);
        _this.loading = false;
      });
    },
    getTenant: function getTenant() {
      var _this2 = this;

      var domain = getTopUrl(); // 临时指定域名，方便测试
      //domain = "https://bladex.vip";

      info(domain).then(function (res) {
        var data = res.data;

        if (data.success && data.data.tenantId) {
          _this2.form.tenantId = data.data.tenantId;
          _this2.tenantMode = false;
        }
      });
    }
  }
};